module.exports = __webpack_public_path__ + "img/Interiores.7b97b1f5.png";